/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, computed, input, output} from '@angular/core';
import {ActiveFilter} from '../../utils/active-filters.util';

/** The "Active Search Criteria" box shown beside a grid's title: one removable chip per active column filter. */
@Component({
    selector: 'app-active-search-criteria',
    templateUrl: './active-search-criteria.component.html',
    styleUrls: ['./active-search-criteria.component.scss'],
    standalone: false
})
export class ActiveSearchCriteriaComponent {
    readonly filters = input.required<ActiveFilter[]>();
    /** Headers of filters the user may not remove, such as defaults required for read-only users. */
    readonly lockedKeys = input<string[]>([]);
    readonly remove = output<string>();
    readonly removeAll = output<void>();

    readonly removableCount = computed(() => this.filters().filter(f => !this.lockedKeys().includes(f.key)).length);

    isLocked(key: string): boolean {
        return this.lockedKeys().includes(key);
    }
}
